module.exports = __webpack_public_path__ + "img/icon_location_bigparking.b8bf28e8.svg";